export const getCurrentTemplate = (state) => state.currentTemplate
